export const namespace = 'numericQuestion';
